import { getLocalStorageItem } from '../shared-functions/LocalStorage';

/**
 * Function to get auth token from localStorage
 */
const getToken = () => {
  const token =
    getLocalStorageItem('token') || getLocalStorageItem('adhocToken');
  if (token) {
    return token;
  }
  return null;
};

export default getToken;
